module.exports = __webpack_public_path__ + "static/media/close-Icon.4df87925.svg";